import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import 'swiper/css/bundle';
import 'swiper/css/pagination';

Swiper.use([Navigation, Pagination]);
export default class Main {
    constructor() {
        this.slideNum = 0;
        this.swiper = null;
        this.init();
    }

    init() {
        this.acc();
        this.initSlider();

        // リサイズ時の処理
        const resize = () => {

            let timeoutID = 0;
            let delay = 200;

            window.addEventListener("resize", () => {
                clearTimeout(timeoutID);
                timeoutID = setTimeout(() => {
                    this.branchProcess();
                }, delay);
            }, false);
        };

        resize();
    }

    acc() {
        const elements = document.querySelectorAll('.more');

        Array.from(elements).forEach(function (el) {

            // ボタンを取得
            const btn = el.querySelector('.more__btn');
            // コンテンツを取得
            const content = el.querySelector('.more__content');

            // ボタンクリックでイベント発火
            btn.addEventListener('click', function () {

                if (!content.classList.contains('open')) {
                    // コンテンツの実際の高さを代入
                    // キーワード値（none、max-content等）では動作しないので注意
                    content.style.maxHeight = content.scrollHeight + 'px';
                    // openクラスを追加
                    content.classList.add('open');
                    // 詳細ボタンのテキストを設定
                    btn.textContent = '閉じる';
                } else {
                    // コンテンツの高さを固定値を代入
                    content.style.maxHeight = '42px';
                    // openクラスを削除
                    content.classList.remove('open');
                    // 詳細ボタンのテキストを設定
                    btn.textContent = '詳細';
                }
            });
        });
    }

    initSlider() {
        this.slideNum = document.querySelector('.post__lineup__list').childElementCount;
        this.branchProcess();
    }

    branchProcess() {
        const windowWidth = window.innerWidth;

        // すでにあったら初期化
        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = undefined;
        }

        if (this.slideNum > 10 || windowWidth < 835) {
            // スライドが10枚以上 or SP
            this.normalSlider();
        } else {
            // スライドが10枚以下
            this.noLoopSlider();
        }
    }

    normalSlider() {
        this.swiper = new Swiper(".post__lineup .swiper-container", {
            // Optional parameters
            slidesPerView: 4.2,
            centeredSlides: true,
            loop: true,
            speed: 500,

            breakpoints: {
                835: {
                    slidesPerView: 10.5,
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            on: {
                init: function () {
                    const itemElm = document.querySelectorAll('.post__lineup__list__item');
                    let currentNum = 0;

                    [...itemElm].forEach((el) => {
                        if (el.classList.contains('-active')) {
                            currentNum = Number(el.dataset.swiperSlideIndex);
                        }
                    });

                    this.slideToLoop(currentNum, 0, false);
                }
            },
        });
    }

    noLoopSlider() {
        this.swiper = new Swiper(".post__lineup .swiper-container", {
            // Optional parameters
            slidesPerView: 10.5,
            speed: 500,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }
}
